import parse from 'html-react-parser';
const Details = ({ data, classList }) => {
	const formattedText = data.description
		.replace(/\^(.*?)\^/g, '<span class="text-secondary font-medium">$1</span>') // Replace ^text^
		.replace(/\*(.*?)\*/g, '<span class="text-primary font-medium">$1</span>');  // Replace *text*
	return (
		<p className={classList}>{parse(formattedText)}</p>
	)
}

export default Details;